<template>
  <div>
    <div class="BlockList" v-show="flog">
      <div class="BlockList-W">
        <div class="sign_close">
          <img src="../../../assets/pc/Logo/close.png" @click="close" />
        </div>
        <div class="signbox">
          <div class="sign_tit1">Sign Up</div>
          <div class="sign_tit2">
            Already have an account?<span @click="signin">Sign in here</span>
          </div>
          <div class="sign_form">
            <el-form ref="form" :model="form" :rules="rules">
              <div class="putext">
                <div class="puttit">Email</div>
                <el-form-item prop="email">
                  <el-input
                    v-model="form.email"
                    class="inpttext"
                    placeholder="Enter your email address"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="putext">
                <div class="puttit">Password</div>
                <el-form-item prop="password">
                  <el-input
                    type="password"
                    v-model="form.password"
                    class="inpttext"
                    show-password
                    placeholder="Enter your password"
                  ></el-input>
                  <!-- <el-input v-model="form.email" class="inpttext"></el-input> -->
                </el-form-item>
              </div>
              <div class="putext">
                <div class="puttit">Confirm password</div>
                <el-form-item prop="repassword">
                  <el-input
                    type="password"
                    v-model="form.repassword"
                    class="inpttext"
                    placeholder="Enter password again"
                    show-password
                  ></el-input>
                  <!-- <el-input v-model="form.email" class="inpttext"></el-input> -->
                </el-form-item>
              </div>
              <!-- <div class="putext">
                <div class="puttit">Captcha</div>
                
                <div style="display: inline-block">
                  <verify
                    @success="onVerifySuccess"
                    @error="onVerifyError"
                  ></verify>
                </div>
              </div> -->
              <div class="putext">
                <div class="puttit">Captcha</div>
                <div style="display: flex; justify-content: space-between">
                  <!-- <div style="display: inline-block">
                  <verify
                    @success="onVerifySuccess"
                    @error="onVerifyError"
                    v-model="form.code"
                  ></verify>
                </div> -->
                  <el-form-item prop="validCode">
                    <el-input
                      v-model="form.validCode"
                      class="inpttext"
                      style="width: 218px"
                      placeholder=""
                      size="medium"
                    ></el-input>
                  </el-form-item>
                  <Code @input="createValidCode" :flog="flog"></Code>
                </div>
              </div>
              <div
                class="submit"
                :class="{ submit1: isFormValid() }"
                @click="Create"
              >
                Create
              </div>
            </el-form>
          </div>
        </div>
      </div>
      <!-- <div class="BlockList-Ws" v-show="flog1">
        <div class="email_img">
          <img src="../../../assets/pc/Logo/email.png" />
        </div>
        <div class="email_tit">Verify Your Email</div>
        <div class="email_tit1">
          Your account registration has been submitted and is pending email
          verification.
        </div>
        <div class="email_cont">
          We have sent an email to <span>302628178@qq.com</span>with a link to
          activate your account. To complete the sign-up process, please click
          on the confirmation link in the email.
        </div>
      </div>
      <div class="BlockList-Wss" v-show="flog2">
        <div class="email_img">
          <img src="../../../assets/pc/Logo/email.png" />
        </div>
        <div class="email_tit">Congratulations!</div>
        <div class="email_tit1">
          You’ve successfully activated your<br />
          account!
        </div>
        <div class="email_cont">
          Go to sign ln<img src="../../../assets/pc/Logo/left.png" />
        </div>
      </div> -->
    </div>
    <div class="BlockList" v-show="flog1">
      <div class="BlockList-Ws">
        <img
          class="images"
          src="../../../assets/pc/Logo/close.png"
          @click="close1"
        />
        <div class="email_img">
          <img src="../../../assets/pc/Logo/email.png" />
        </div>
        <div class="email_tit">Verify Your Email</div>
        <div class="email_tit1">
          Your account registration has been submitted and is pending email
          verification.
        </div>
        <div class="email_cont">
          We have sent an email to
          <span style="margin-right: 4px"> {{ emails }}</span
          >with a link to activate your account. To complete the sign-up
          process, please click on the confirmation link in the email.
        </div>
      </div>
    </div>
    <!-- <div class="BlockList" v-show="flog2">
      <div class="BlockList-Wss">
        <div class="email_img">
          <img src="../../../assets/pc/Logo/email.png" />
        </div>
        <div class="email_tit">Congratulations!</div>
        <div class="email_tit1">
          You’ve successfully activated your<br />
          account!
        </div>
        <div class="email_cont">
          Go to sign ln<img src="../../../assets/pc/Logo/left.png" />
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
// import Verify from "vue2-verify";
import { activateUser } from "@/assets/server/api";
import Code from "@/views/pc/Login/code.vue";
import { register } from "@/assets/server/api";
export default {
  // props: ["flogb"],
  props: ["floag", "flogb"],
  data() {
    return {
      isVerify: false,
      form: {
        email: "",
        password: "",
        repassword: "",
        validCode: "",
      },
      rules: {
        email: [
          {
            required: true,
            message: "email  is required",
            trigger: "change",
          },
          {
            type: "email",
            message: "Please enter a valid email address",
            trigger: ["blur", "change"],
          },
        ],
        password: [
          {
            required: true,
            message: "password  is required",
            trigger: "change",
          },
          {
            min: 6,
            max: 12,
            message: "Please enter a password between 6 and 12 characters.",
            trigger: "blur",
          },
        ],
        repassword: [
          {
            required: true,
            message: "repassword  is required",
            trigger: "change",
          },
          {
            min: 6,
            max: 12,
            message: "Please enter a password between 6 and 12 characters.",
            trigger: "blur",
          },
        ],
        validCode: [
          {
            required: true,
            message: "code is required",
            trigger: "change",
          },
        ],
      },
      flog: this.flogb, //注册
      floga: this.floag, //登录
      flog1: false, //激活邮箱
      flog2: false, //激活邮箱成功
      emails: "", //展现在页面上的email
      validCode: "",
    };
  },
  components: {
    // Verify,
    Code,
  },
  created() {},
  mounted() {},
  watch: {
    deep: true,
    flogb(val) {
      this.flog = val;
      //console.log(this.flog);
      this.$refs.form.clearValidate();
      this.form.email = "";
      this.form.password = "";
      this.form.repassword = "";
      this.form.validCode = "";
    },
  },
  methods: {
    isFormValid() {
      // Check if all required fields have values
      return (
        this.form.email.trim() !== "" &&
        this.form.password.trim() !== "" &&
        this.form.repassword.trim() !== "" &&
        this.form.validCode.trim() !== ""
      );
    },
    // submit() {
    //  console.log('点击了');
    //   this.isVerify = false;
    //   this.$nextTick(() => {
    //     this.isVerify = true;
    //   });
    // },
    //接收验证码组件提交的4位验证码
    createValidCode(data) {
      this.validCode = data;
    //  console.log(this.validCode);
    },
    validatePassword() {
      return this.form.password === this.form.repassword;
    },
    //点击进行注册
    async Create() {
      this.$refs.form.validate(async (success) => {
        if (this.validatePassword()) {
      //    console.log(this.form);
          if (success) {
            if (
              this.form.validCode.toLowerCase() !== this.validCode.toLowerCase()
            ) {
              this.$message.error("Error in verification code");
              return;
            }
            const params = {
              email: this.form.email,
              password: this.form.password,
            };
            const formData = new FormData();
            const item = params;
            for (const key in item) {
              if (Object.hasOwnProperty.call(item, key)) {
                formData.append(key, item[key]);
              }
            }
            let data = await register(formData);
        //    console.log(data);
            if (data.code == 200) {
              this.flog1 = true;
              this.flog = false;
              //  this.$emit("signups", this.flog);
              this.emails = data.result;
              this.form.email = "";
              this.form.password = "";
              this.form.repassword = "";
              this.form.validCode = "";

              //  this.Createemail();
            } else {
              this.$message(data.result);
            }
          } else {
            this.$message(" This field are not filled in ");
            return false;
          }
        } else {
          this.$message(" Passwords do not match ");
          return false;
        }
      });
    },
    signin() {
      console.log("点击登录");
      // console.log(this.flogb);
      this.$refs.form.clearValidate();
      this.flog = false;
      this.$emit("signups", this.flog);
      this.floga = true;
      this.$emit("loginflog", this.floga);
    },
    // onVerifySuccess(obj) {
    //   this.isVerify = true;
    //   //验证码正确回调
    //   console.log(obj);
    //   console.log("verify success");
    //   //todo
    // },
    // onVerifyError(obj) {
    //   this.isVerify = false;
    //   //验证码错误回调
    //   console.log("verify error");
    //   //错误刷新验证码
    //   obj.refresh();
    //   //todo
    // },
    close() {
      this.flog = false;
      this.$emit("signups", this.flog);

      this.form.email = "";
      this.form.password = "";
      this.form.repassword = "";
      this.form.validCode = "";
      this.$refs.form.clearValidate();
    },
    //注册成功调用页面关闭
    close1() {
      this.flog1 = false;
    //  console.log("只想洗的" + this.flog);
      this.$emit("signups", this.flog);
      this.$refs.form.clearValidate();
    },
    // async Createemail() {
    //   const params = {
    //     email: this.emailValue,
    //   };
    //   const formData = new FormData();
    //   const item = params;
    //   for (const key in item) {
    //     if (Object.hasOwnProperty.call(item, key)) {
    //       formData.append(key, item[key]);
    //     }
    //   }
    //   let data = await activateUser(formData);
    //   console.log(data);
    //   if (data.code == 200) {
    //     this.flog1=true;
    //     this.$message(data.result);
    //   //  this.emails = data.result;
    //   }else if(data.code==400){
    //     this.flog2=true;
    //     this.$message(data.result);
    //   }

    // },
  },
};
</script>

<style lang="less">
/deep/.el-message {
  z-index: 9999999;
  background-color: #fff !important;
  /* 设置文本颜色为白色 */
  color: white !important;
  /* 其他样式调整，根据需要自行添加 */
}
</style>
<style lang="less" scoped>
/deep/.el-input__inner {
  color: #ffffff !important;
}
/deep/.el-input__inner::placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
}
.BlockList {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  // height: 1000px !important;
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  overflow: auto;
  .BlockList-W {
    width: 428px;
    height: 582px;
    background: #13161b;
    border-radius: 20px 20px 20px 20px;
    opacity: 1;
    position: absolute;
    // border: 1px solid red;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .sign_close {
      margin-left: 388px;
      margin-top: 18px;
      img {
        width: 24px;
        height: 24px;
      }
    }
    .signbox {
      width: 348px;
      margin: 0 auto;

      .sign_tit1 {
        height: 33px;
        font-size: 28px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: #ffffff;
        line-height: 33px;
        text-align: center;
      }
      .sign_tit2 {
        height: 15px;
        font-size: 13px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        color: #ffffff;
        line-height: 15px;
        text-align: center;
        margin-top: 8px;
        span {
          color: #02d28e;
          cursor: pointer;
          margin-left: 8px;
        }
      }
      .sign_form {
        padding-top: 15px;
        .putext {
          /deep/.verify-change-code {
            display: none;
          }
          /deep/.verify-btn {
            display: none;
          }
          /deep/.cerify-code-panel {
            display: flex;
            // justify-content: space-between;
          }
          /deep/.verify-code {
            width: 200px !important;
            height: 46px !important;
            line-height: 46px !important;
            border-radius: 20px !important;
            border: none !important;
          }
          /deep/.varify-input-code {
            width: 110px;
            height: 48px;
            background: #000000;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            border: 1px solid #000000;
            border: none;
            margin-left: 30px;
            color: #fff;
            padding-left: 20px;
          }
          margin-bottom: 23px;
          .puttit {
            height: 18px;
            font-size: 15px;
            font-family: Roboto, Roboto;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.5);
            line-height: 18px;
            margin-bottom: 8px;
          }
          .inpttext {
            width: 348px;
            height: 48px;
            background: #000000;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            border: 1px solid #000000;
            /deep/ .el-input__inner {
              background: #000000;
              border: none;
              color: #fff;
            }
          }
        }
        .submit {
          width: 348px;
          height: 48px;
          margin-top: -16px;
          line-height: 48px;
          background: #333b3b;
          border-radius: 10px 10px 10px 10px;
          opacity: 1;
          font-size: 16px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #858989;
          text-align: center;
          cursor: pointer;
        }
        .submit1 {
          width: 348px;
          height: 48px;
          line-height: 48px;
          background: #00e79a;
          border-radius: 10px 10px 10px 10px;
          opacity: 1;
          font-size: 16px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #13161b;
          text-align: center;
          cursor: pointer;
        }
      }
    }
  }
  .BlockList-Ws {
    width: 590px;
    height: 379px;
    background: #13161b;
    border-radius: 20px 20px 20px 20px;
    opacity: 1;
    position: absolute;
    // border: 1px solid red;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .images {
      width: 24px;
      height: 24px;
      margin-top: 16px;
      margin-left: 550px;
      cursor: pointer;
    }
    .email_img {
      margin-top: 22px;
      margin-left: 255px;
      img {
        width: 79px;
        height: 64px;
      }
    }
    .email_tit {
      margin-top: 24px;
      margin-left: 187px;
      height: 33px;
      font-size: 28px;
      font-family: Roboto, Roboto;
      font-weight: 500;
      color: #ffffff;
      line-height: 33px;
    }
    .email_tit1 {
      width: 510px;
      height: 68px;
      border-radius: 12px 12px 12px 12px;
      opacity: 1;
      border: 1px solid #02d28e;
      margin: 0 auto;
      padding-top: 10px;
      padding-left: 14px;
      margin-top: 15px;
      cursor: pointer;
      font-size: 16px;
      font-family: Roboto, Roboto;
      font-weight: 400;
      color: #02d28e;
      line-height: 24px;
    }

    .email_cont {
      width: 510px;
      height: 72px;
      font-size: 16px;
      font-family: Roboto, Roboto;
      font-weight: 400;
      color: #ffffff;
      line-height: 24px;
      margin: 0 auto;
      margin-top: 15px;

      span {
        cursor: pointer;
        color: #02d28e;
        margin-left: 2px;
      }
    }
  }
  .BlockList-Wss {
    width: 357px;
    height: 307px;
    background: #0b0c0f;
    border-radius: 20px 20px 20px 20px;
    opacity: 1;
    position: absolute;
    // border: 1px solid red;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .email_img {
      margin-top: 43px;
      margin-left: 139px;
      img {
        width: 79px;
        height: 64px;
      }
    }
    .email_tit {
      margin-top: 26px;
      // margin-left: 187px;
      height: 20px;
      font-size: 24px;
      font-family: Roboto, Roboto;
      font-weight: 500;
      color: #00e79a;
      line-height: 20px;
      text-align: center;
    }
    .email_tit1 {
      margin-top: 12px;
      height: 42px;
      font-size: 14px;
      font-family: Roboto, Roboto;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.8);
      line-height: 21px;
      text-align: center;
    }
    .email_cont {
      margin-top: 32px;
      height: 21px;
      font-size: 15px;
      font-family: Roboto, Roboto;
      font-weight: 400;
      color: #ffffff;
      line-height: 21px;
      margin-left: 127px;
      img {
        width: 16px;
        height: 16px;
        margin-top: 5px;
      }
    }
  }
}
</style>
